import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import { ReactComponent as ProcurementIcon } from "assets/icons/tradeRelationShips.svg";
import { ReactComponent as CounterpartyIcon } from "assets/icons/tradeSingle.svg";
import { ReactComponent as AutomationIcon } from "assets/icons/tradeAutomationHandles.svg";

export const FeatureGridSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  return (
    <section className="feature-section">
      <div className="feature-content-block">
        <div className="feature-grid">
          <div className="feature-grid__col feature-grid__col--left">
            <div className="feature-card feature-card--tall">
              <div className="feature-card__icon-box">
                <CounterpartyIcon />
              </div>
              <h3 className="feature-card__title">
                {strings.feature_counterparty_title ||
                  "A single, trusted counterparty"}
              </h3>
              <p className="feature-card__text">
                {strings.feature_counterparty_desc ||
                  "Ezer acts as principal on every transaction, so you're never exposed to a supplier you've never met. One relationship carries the accountability that used to sit with dozens."}
              </p>
            </div>
          </div>

          <div className="feature-grid__col">
            <div className="feature-card">
              <div className="feature-card__icon-box">
                <ProcurementIcon />
              </div>
              <h3 className="feature-card__title">
                {strings.feature_procurement_title ||
                  "Established procurement relationships"}
              </h3>
              <p className="feature-card__text">
                {strings.feature_procurement_desc ||
                  "You draw on Ezer's existing network of pre-vetted global suppliers and commodity sourcing expertise, built over years of direct trading relationships — not a cold introduction."}
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-card__icon-box">
                <AutomationIcon />
              </div>
              <h3 className="feature-card__title">
                {strings.feature_automation_title ||
                  "Automation handles the complexity"}
              </h3>
              <p className="feature-card__text">
                {strings.feature_automation_desc ||
                  "Contract management runs automatically and logistics visibility updates in real time, so the operational load of an international order never lands on your desk."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
